
export const formatDate = (date, endOfDay = false) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  if (endOfDay) {
    return `${year}-${month}-${day}T23:59:59.999`;
  }
  return `${year}-${month}-${day}T00:00:00.000`;
};

/**
 * Transforms relative date ranges (like '1d', '2w', '3m') into absolute date ranges
 * with 'from' and 'to' timestamps.
 * 
 * How it works:
 * - The 'to' date is always the END of today (23:59:59.999)
 * - The 'from' date is calculated by going back the specified period
 * - The range INCLUDES the current day as the last day
 * 
 * Examples:
 *   relativeDateRange='1d' → from: today at 00:00, to: today at 23:59
 *   relativeDateRange='1w' → from: 6 days ago at 00:00, to: today at 23:59 (7 days total)
 *   relativeDateRange='2d' → from: yesterday at 00:00, to: today at 23:59 (2 days total)
 *   relativeDateRange='1m' → from: 1 month ago at 00:00, to: today at 23:59
 * 
 * @param {string} relativeDateRange - Format: number + unit (d=days, w=weeks, m=months)
 * @returns {Object} Object with 'from' and 'to' properties in format: YYYY-MM-DDT00:00:00.000
 */
export const getDatesFromRelativeRange = (relativeDateRange) => {
  // Current date for 'to' value (end of today)
  const now = new Date();
  const to = formatDate(now, true);

  // Calculate 'from' date based on relative range
  const fromDate = new Date();
  const [, amount, unit] = relativeDateRange.match(/(\d+)([dwm])/);
  const numericAmount = parseInt(amount);

  switch (unit) {
    case 'd':
      fromDate.setDate(fromDate.getDate() - numericAmount + 1);
      break;
    case 'w':
      fromDate.setDate(fromDate.getDate() - (numericAmount * 7) + 1);
      break;
    case 'm':
      fromDate.setMonth(fromDate.getMonth() - numericAmount);
      break;
  }

  const from = formatDate(fromDate);

  return { from, to };
};